<!--
 * @Description: 资源上传
 * @Author: gao shuai
 * @Date: 2020-03-08 09:26:13
 * @LastEditTime: 2020-08-03 17:33:14
 * @LastEditors: gao shuai
 -->

<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>资源上传</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="gs_tablestyle">
      <div class="gs_title">端游网关上传</div>
      <table>
        <tr>
          <td width="150" class="tit">传奇网关：</td>
          <td width="250" style="border-right:none">
            <el-upload
              class="upload-demo"
              ref="upload1"
              :limit="1"
              action=""
              :on-remove="remove1"
              :on-change="imgchange1"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                class="transtionbtn"
                :class="{ on: fileList1.length < 1 }"
                size="small"
                type="success"
                >选取文件</el-button
              >
            </el-upload>
          </td>
          <td style="border-left:none" width="80">
            <el-button
              size="small"
              type="primary"
              @click="submitUpload1"
              :loading="!flag1"
              >上传</el-button
            >
          </td>
          <td>
            <span class="red"
              >【有新版本网关在此处上传即可,上传后GM可在老版本网关点击升级网关,即可升级为最新网关,并且会自动备份老网关】</span
            >
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">传奇3网关：</td>
          <td width="250" style="border-right:none">
            <el-upload
              class="upload-demo"
              ref="upload3"
              :limit="1"
              action=""
              :on-remove="remove3"
              :on-change="imgchange3"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                class="transtionbtn"
                :class="{ on: fileList3.length < 1 }"
                size="small"
                type="success"
                >选取文件</el-button
              >
            </el-upload>
          </td>
          <td style="border-left:none" width="80">
            <el-button
              size="small"
              type="primary"
              @click="submitUpload3"
              :loading="!flag3"
              >上传</el-button
            >
          </td>
          <td>
            <span class="red"
              >【有新版本网关在此处上传即可,上传后GM可在老版本网关点击升级网关,即可升级为最新网关,并且会自动备份老网关】</span
            >
          </td>
        </tr>
      </table>
    </div>

    <div class="gs_tablestyle mgt15">
      <div class="gs_title">手游接口上传</div>
      <table>
        <tr>
          <td width="150" class="tit">接口名称：</td>
          <td>
            <el-input
              size="small"
              v-model="gameName"
              placeholder="请输入内容"
            ></el-input>
          </td>
          <td style="border-left:none" width="80"></td>
          <td>
            <span class="red">【建议填写手游名称】</span>
          </td>
            </tr>
            <tr>
              <td width="150" class="tit">接口说明：</td>
              <td colspan="3">
                <el-input resize="false"  placeholder="请输入内容" v-model="gameRemark"></el-input>
              </td>
            </tr>
            <tr>
          <td width="150" class="tit">文件上传：</td>
          <td width="250" style="border-right:none">
            <el-upload
              class="upload-demo"
              ref="upload4"
              :limit="1"
              action=""
              :on-remove="remove4"
              :on-change="imgchange4"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                class="transtionbtn"
                :class="{ on: fileList4.length < 1 }"
                size="small"
                type="success"
                >选取文件</el-button
              >
            </el-upload>
          </td>
          <td style="border-left:none" width="80">
            <el-button
              size="small"
              type="primary"
              @click="submitUpload4"
              :loading="!flag4"
              >上传</el-button
            >
          </td>
          <td>
            <span class="red">【文件上传后商户页面会立即展示】</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="gs_tablestyle mgt15">
      <div class="gs_title">网站资源设置</div>
      <table>
        <tr>
          <td width="150" class="tit">网站logo：</td>
          <td width="250" style="border-right:none">
            <el-upload
              class="upload-demo"
              ref="upload11"
              :limit="1"
              action=""
              accept=".png"
              :on-remove="remove11"
              :on-change="imgchange11"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                class="transtionbtn"
                :class="{ on: fileList11.length < 1 }"
                size="small"
                type="success"
                >选取文件</el-button
              >
            </el-upload>
          </td>
          <td style="border-left:none;" width="80">
            <el-button
              size="small"
              type="primary"
              @click="submitUpload11"
              :loading="!flag11"
              >上传</el-button
            >
          </td>
          <td>
            <img
              style="height:36px;width:auto;display:block;"
              :src="imgurl11"
              alt=""
            />
          </td>
          <td>
            <span style="color:red;"
              >【网站logo图片为png格式------建议尺寸:270 * 60 pixels】</span
            >
          </td>
        </tr>
        <!-- <tr>
          <td width="150" class="tit">网站LOGO(小)：</td>
          <td width="250" style="border-right:none">
            <el-upload class="upload-demo" ref="upload6" :limit="1" action="" accept=".png" :on-remove="remove6" :on-change="imgchange6" :auto-upload="false">
              <el-button slot="trigger" class="transtionbtn" :class="{'on':fileList6.length<1}" size="small" type="success">选取文件</el-button>
            </el-upload>
          </td>
          <td style="border-left:none;" width="80">
            <el-button size="small" type="primary" @click="submitUpload6" :loading="!flag6">上传</el-button>
          </td>
          <td>
            <img style="height:36px;width:auto;display:block;" :src="imgurl6" alt="">
          </td>
          <td>
            <span style="margin-left: 20px;color:red;">【网站小logo图片为png格式------建议尺寸:105 * 60 pixels】</span>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">首页横幅：</td>
          <td width="250" style="border-right:none">
            <el-upload class="upload-demo" ref="upload7" :limit="1" action="" accept=".jpg,.jpeg" :on-remove="remove7" :on-change="imgchange7" :auto-upload="false">
              <el-button slot="trigger" class="transtionbtn" :class="{'on':fileList7.length<1}" size="small" type="success">选取文件</el-button>
            </el-upload>
          </td>
          <td style="border-left:none;" width="80">
            <el-button size="small" type="primary" @click="submitUpload7" :loading="!flag7">上传</el-button>
          </td>
          <td>
            <img style="height:36px;width:auto;display:block;" :src="imgurl7" alt="">
          </td>
          <td>
            <span style="margin-left: 20px;color:red;">【首页横幅图片为jpg格式------建议尺寸1920 * 800 pixels】</span>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">注册横幅：</td>
          <td width="250" style="border-right:none">
            <el-upload class="upload-demo" ref="upload8" :limit="1" action="" accept=".jpg,.jpeg" :on-remove="remove8" :on-change="imgchange8" :auto-upload="false">
              <el-button slot="trigger" class="transtionbtn" :class="{'on':fileList8.length<1}" size="small" type="success">选取文件</el-button>
            </el-upload>
          </td>
          <td style="border-left:none;" width="80">
            <el-button size="small" type="primary" @click="submitUpload8" :loading="!flag8">上传</el-button>
          </td>
          <td>
            <img style="height:36px;width:auto;display:block;" :src="imgurl8" alt="">
          </td>
          <td>
            <span style="margin-left: 20px;color:red;">【注册横幅图片为jpg格式------建议尺寸:1920 * 400 pixels】</span>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">资费横幅：</td>
          <td width="250" style="border-right:none">
            <el-upload class="upload-demo" ref="upload9" :limit="1" action="" accept=".jpg,.jpeg" :on-remove="remove9" :on-change="imgchange9" :auto-upload="false">
              <el-button slot="trigger" class="transtionbtn" :class="{'on':fileList9.length<1}" size="small" type="success">选取文件</el-button>
            </el-upload>
          </td>
          <td style="border-left:none;" width="80">
            <el-button size="small" type="primary" @click="submitUpload9" :loading="!flag9">上传</el-button>
          </td>
          <td>
            <img style="height:36px;width:auto;display:block;" :src="imgurl9" alt="">
          </td>
          <td>
            <span style="margin-left: 20px;color:red;">【资费横幅图片为jpg格式------建议尺寸:1920 * 200 pixels】</span>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">我们横幅：</td>
          <td width="250" style="border-right:none">
            <el-upload class="upload-demo" ref="upload10" :limit="1" action="" accept=".jpg,.jpeg" :on-remove="remove10" :on-change="imgchange10" :auto-upload="false">
              <el-button slot="trigger" class="transtionbtn" :class="{'on':fileList10.length<1}" size="small" type="success">选取文件</el-button>
            </el-upload>
          </td>
          <td style="border-left:none;" width="80">
            <el-button size="small" type="primary" @click="submitUpload10" :loading="!flag10">上传</el-button>
          </td>
          <td>
            <img style="height:36px;width:auto;display:block;" :src="imgurl10" alt="">
          </td>
          <td>
            <span style="margin-left: 20px;color:red;">【关于我们横幅图片为jpg格式------建议尺寸:1024 * 250 pixels】</span>
          </td>
        </tr> -->
        <tr>
          <td width="150" class="tit">微信客服二维码：</td>
          <td width="250" style="border-right:none">
            <el-upload
              class="upload-demo"
              ref="upload12"
              :limit="1"
              action=""
              accept=".png,.jpg,.jpeg"
              :on-remove="remove12"
              :on-change="imgchange12"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                class="transtionbtn"
                :class="{ on: fileList12.length < 1 }"
                size="small"
                type="success"
                >选取文件</el-button
              >
            </el-upload>
          </td>
          <td style="border-left:none;" width="80">
            <el-button
              size="small"
              type="primary"
              @click="submitUpload12"
              :loading="!flag12"
              >上传</el-button
            >
          </td>
          <td>
            <img
              style="height:36px;width:auto;display:block;"
              :src="imgurl12"
              alt=""
            />
          </td>
          <td>
            <span style="color:red;">【微信客服二维码】</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="gs_tablestyle mgt15">
      <div class="gs_title">开区助手设置</div>
      <table>
        <tr>
          <td width="150" class="tit">开区助手：</td>
          <td width="250" style="border-right:none">
            <el-upload
              class="upload-demo"
              ref="upload13"
              :limit="1"
              action=""
              :on-remove="remove13"
              :on-change="imgchange13"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                class="transtionbtn"
                :class="{ on: fileList13.length < 1 }"
                size="small"
                type="success"
                >选取文件</el-button
              >
            </el-upload>
          </td>
          <td style="border-left:none" width="80">
            <el-button
              size="small"
              type="primary"
              @click="submitUpload13"
              :loading="!flag13"
              >上传</el-button
            >
          </td>
          <td>
            <span class="red">【上传开区助手，之前上传的文件会被备份】</span>
          </td>
        </tr>
      </table>
    </div>

    <div class="gs_tablestyle mgt15">
      <div class="gs_title">通用文件上传</div>
      <table>
        <tr>
          <td width="150" class="tit">文件名称：</td>
          <td>
            <el-input
              size="small"
              v-model="commonName"
              placeholder="请输入内容"
            ></el-input>
          </td>
          <td style="border-left:none" width="80"></td>
          <td>
            <span class="red">【文件将通过文件名检索并下载】</span>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">文件说明：</td>
          <td colspan="3">
            <el-input
              resize="false"
              type="textarea"
              placeholder="请输入内容"
              v-model="commonRemark"
            ></el-input>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">文件上传：</td>
          <td width="250" style="border-right:none">
            <el-upload
              class="upload-demo"
              ref="upload14"
              :limit="1"
              action=""
              :on-remove="remove14"
              :on-change="imgchange14"
              :auto-upload="false"
            >
              <el-button
                slot="trigger"
                class="transtionbtn"
                :class="{ on: fileList14.length < 1 }"
                size="small"
                type="success"
                >选取文件</el-button
              >
            </el-upload>
          </td>
          <td style="border-left:none" width="80">
            <el-button
              size="small"
              type="primary"
              @click="submitUpload14"
              :loading="!flag14"
              >上传</el-button
            >
          </td>
          <td>
            <span class="red">【同名文件将会被备份】</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameName: '',
      gameRemark: '',
      commonName: '',
      commonRemark: '',
      fileList1: [], // 传奇网关
      fileList3: [], // 传奇3网关
      fileList4: [], // 传奇3网关
      fileList11: [], // Logo
      fileList12: [], // 二维码
      fileList13: [], // 网关助手
      fileList14: [], // 通用上传
      flag1: true,
      flag3: true,
      flag4: true,
      flag11: true,
      flag12: true,
      flag13: true,
      flag14: true,
      imgurl5: '', // 网站logo
      imgurl6: '', // 网站LOGO(小)
      imgurl7: '', // 首页横幅
      imgurl8: '', // 注册横幅
      imgurl9: '', // 资费横幅
      imgurl10: '', // 我们横幅
      imgurl11: '', // logo
      imgurl12: '' // 二维码
    };
  },
  methods: {
    /* ----------------------1.传奇网关----------------------- */
    remove1(file, fileList) {
      this.fileList1 = fileList;
    },
    imgchange1(file, fileList) {
      this.fileList1 = fileList;
    },
    submitUpload1() {
      if (this.fileList1.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag1) {
        this.flag1 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList1[0].raw);
      this.$api.systemset
        // .uploadFileNew(form, 'Wg')
        .uploadFileNew(form, 'Wg', 'Global')
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload1.clearFiles();
          this.fileList1 = [];
          this.flag1 = true;
        })
        .catch(err => {
          this.flag1 = true;
          this.$messageError(err.message);
        });
    },
    /* ----------------------3.传奇3网关----------------------- */
    remove3(file, fileList) {
      this.fileList3 = fileList;
    },
    imgchange3(file, fileList) {
      this.fileList3 = fileList;
    },
    submitUpload3() {
      if (this.fileList3.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag3) {
        this.flag3 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList3[0].raw);
      this.$api.systemset
        // .uploadFileNew(form, 'Cq3')
        .uploadFileNew(form, 'Cq3', 'Global')
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload3.clearFiles();
          this.fileList3 = [];
          this.flag3 = true;
        })
        .catch(err => {
          this.$messageError(err.message);
          this.flag3 = true;
        });
    },
    /* ----------------------4.手游接口网关----------------------- */
    remove4(file, fileList) {
      this.fileList4 = fileList;
    },
    imgchange4(file, fileList) {
      this.fileList4 = fileList;
    },
    submitUpload4() {
      if (this.gameName === '') {
        this.$messageError('请输入游戏名称！');
        return;
      }
      if (this.fileList4.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag4) {
        this.flag4 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList4[0].raw);
      this.$api.systemset
        .uploadFileNew(
          form,
          escape(this.gameName),
          'MobileGame',
          '0',
          escape(this.gameRemark)
        )
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload4.clearFiles();
          this.fileList4 = [];
          this.flag4 = true;
          this.gameName = '';
          this.gameRemark = '';
        })
        .catch(err => {
          this.$messageError(err.message);
          this.flag4 = true;
        });
    },
    /* ----------------------11.logo----------------------- */
    remove11(file, fileList) {
      this.fileList11 = fileList;
    },
    imgchange11(file, fileList) {
      this.fileList11 = fileList;
    },
    submitUpload11() {
      if (this.fileList11.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag11) {
        this.flag11 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList11[0].raw);
      this.$api.systemset
        .uploadFileNew(form, 'Logo', 'Global')
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload11.clearFiles();
          this.fileList11 = [];
          this.getinfo();
          this.flag11 = true;
        })
        .catch(err => {
          this.$messageError(err.message);
          this.flag11 = true;
        });
    },
    /* ----------------------12.二维码----------------------- */
    remove12(file, fileList) {
      this.fileList12 = fileList;
    },
    imgchange12(file, fileList) {
      this.fileList12 = fileList;
    },
    submitUpload12() {
      if (this.fileList12.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag12) {
        this.flag12 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList12[0].raw);
      this.$api.systemset
        .uploadFileNew(form, 'Qr', 'Global')
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload12.clearFiles();
          this.fileList12 = [];
          this.getinfo();
          this.flag12 = true;
        })
        .catch(err => {
          this.$messageError(err.message);
          this.flag12 = true;
        });
    },
    /* ----------------------13.网关助手----------------------- */
    remove13(file, fileList) {
      this.fileList13 = fileList;
    },
    imgchange13(file, fileList) {
      this.fileList13 = fileList;
    },
    submitUpload13() {
      if (this.fileList13.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag13) {
        this.flag13 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList13[0].raw);
      this.$api.systemset
        .uploadFileNew(form, 'Wgzs', 'Global')
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload13.clearFiles();
          this.fileList13 = [];
          this.getinfo();
          this.flag13 = true;
        })
        .catch(err => {
          this.$messageError(err.message);
          this.flag13 = true;
        });
    },
    /* ----------------------14.通用上传----------------------- */
    remove14(file, fileList) {
      this.fileList14 = fileList;
    },
    imgchange14(file, fileList) {
      this.fileList14 = fileList;
    },
    submitUpload14() {
      if (this.fileList14.length < 1) {
        this.$messageError('请选择要上传的文件！');
        return;
      }
      if (this.flag14) {
        this.flag14 = false;
      } else {
        return;
      }
      let form = new FormData();
      form.append('file', this.fileList14[0].raw);
      this.$api.systemset
        .uploadFileNew(
          form,
          escape(this.commonName),
          'Global',
          '0',
          escape(this.commonRemark)
        )
        .then(() => {
          this.$messageSuccess('上传成功！');
          this.$refs.upload14.clearFiles();
          this.fileList14 = [];
          this.flag14 = true;
        })
        .catch(err => {
          this.flag14 = true;
          this.$messageError(err.message);
        });
    },
    // 获取配置信息
    getinfo() {
      this.$api.systemset
        .uploadinfo()
        .then(data => {
          if (data.status === 200) {
            this.imgurl5 = data.data.logo; // 网站logo
            this.imgurl6 = data.data.logoMin; // 网站LOGO(小)
            this.imgurl7 = data.data.index; // 首页横幅
            this.imgurl8 = data.data.register; // 注册横幅
            this.imgurl9 = data.data.fee; // 资费横幅
            this.imgurl10 = data.data.us; // 我们横幅
            this.imgurl11 = data.data.gzh; // 二维码
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    }
  },
  created() {
    this.getinfo();
  }
};
</script>

<style lang="scss" scoped>
.gs_tablestyle {
  background: #fff;
  &::v-deep .upload-demo {
    position: relative;
    height: 32px;
    overflow: hidden;
    .el-upload {
      position: absolute;
      text-align: left;
    }
    .el-upload-list {
      .el-upload-list__item {
        &:first-child {
          margin-top: 0;
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
  table {
    width: 100%;
    .red {
      color: red;
    }
    td {
      padding: 8px;
      border: 1px solid #e4eaec;
    }
    .tit {
      background: #f1f7f9;
      text-align: center;
    }
  }
  .transtionbtn {
    opacity: 0;
    &.on {
      transition: opacity 2s;
      opacity: 1;
    }
  }
}
</style>
